/**
 * Centro de anuncios — lado público (pantalla de login).
 *
 * `GET /announcements` es PÚBLICO (sin auth): devuelve solo los avisos activos,
 * ordenados por fecha. Se consume desde el panel de marca del login, donde no
 * hay sesión: pasamos `skipAuthRefresh:true` para que un eventual 401 NO dispare
 * el ciclo de refresh (no hay sesión que renovar).
 */
import { useQuery } from '@tanstack/react-query';

import { api } from './api';

/** Aviso público (solo activos). */
export interface Announcement {
  id: string;
  title: string;
  /** Traducción PT-BR (null si no se cargó → se usa el título en español). */
  title_pt?: string | null;
  body: string;
  /** Traducción PT-BR (null si no se cargó → se usa el cuerpo en español). */
  body_pt?: string | null;
  created_at: string;
}

export function useAnnouncements() {
  return useQuery({
    queryKey: ['announcements', 'public'],
    queryFn: () =>
      api.get<Announcement[]>('/announcements', { skipAuthRefresh: true }),
    // Contenido informativo: cacheamos un rato para no golpear en cada visita.
    staleTime: 60_000,
    // Sin sesión no tiene sentido reintentar agresivamente.
    retry: 1,
  });
}
